<template>
  <v-alert id="maintenance-card" class="my-0">
    <p class="my-0">
      {{ $t(`views.sign.maintenanceError1`) }}
    </p>
    <p class="mt-3 mb-0">
      {{ $t(`views.sign.maintenanceError2`) }}
    </p>
  </v-alert>
</template>

<script>
export default {}
</script>

<style lang="scss">
#maintenance-card {
  font-size: 16px;
}
</style>
